export default {
  _name: 'zh',
  _iso: 'CHI',
  'Internal Server Error': 'Internal Server Error',
  ERROR_INVALID_WALLET_ADDRESS: '钱包地址不正确',
  ERR_EMPTY_BALANCE: 'Empty balance on this wallet.',
  ERR_WRONG_ETH_ADDRESS: 'Address you provide is not eth address.',
  ERR_ADDRESS_NOT_FOUND: 'We can\'t find address in our DB.',
  ERR_BALANCE_NOT_ENOUGH: 'Minimal withdrawal balance requirement not met.',
  menu: {
    about: '关于我们',
    roadmap: '路线图',
    advisers: '顾问',
    check_tokens: '检查令牌',
    faq: 'FAQ'
  },
  input: {
    placeholder: '请您输入您ETH地址如下'
  },
  footer: 'Have questions? Visit our',
  header: 'Enter your ETH address to calculate your monthly referral commission. Confirm reward withdrawal to receive it to this wallet.',
  divident: {
    text: 'Your monthly referral commission is',
    withdraw: 'Receive Monthly Reward'
  },
  min: 'Minimum withdrawal amount is',
  cancel: 'Cancel',
  confirm: 'Confirm',
  success: 'Ethereum has been sent to your address, the transaction may take a couple of minutes',
  back: 'Back'
}



// WEBPACK FOOTER //
// ./src/langs/zh.js